"use client";
import { useState } from "react";
import EventToggle, { EventTab } from "./EventToggle";
import CityEvents from "./CityEvents";
import VirtualEvents from "./VirtualEvents";

const Category = () => {
  const [activeTab, setActiveTab] = useState<EventTab>("city");
  return (
    <div className="container 2xl:max-w-[1628px]">
      <div className="w-full h-[48px] relative">
        <span className="bg-white text-nowrap inline-block font-medium text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-[32px] ff_poppins text-black absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 z-10 px-3 sm:px-5">
          Browse By Category
        </span>
        <span className="bg-[linear-gradient(90deg,_#1776F0_0%,_#8F3EBC_100%)] h-1 w-full absolute top-1/2 -translate-y-1/2 left-0 z-0"></span>
      </div>
      <p className="ff_poppins font-medium text-base md:text-lg lg:text-xl xl:text-2xl text-center mt-2">
        Connect Without Limits: Explore Immersive Local Gatherings and Global
        Digital Summits
      </p>
      <div className="flex items-center justify-center mt-[34px]">
        <EventToggle value={activeTab} onChange={setActiveTab} />
      </div>
      {activeTab === "city" && <CityEvents />}
      {activeTab === "virtual" && <VirtualEvents />}
    </div>
  );
};
export default Category;
